module.exports = __webpack_public_path__ + "static/plain-funcionalidades1-ed6db5719be8c5dcee0fcccca4a37f3f.png";